import { ActionRegistryCategory } from '../../ActionRegistryCategory';
import { ActionRegistryItem } from '../../ActionRegistryItem';
import { MouseEvent_ } from '../../../../classes/event/eventTypes/MouseEvent_';
export class ActionsEvent extends ActionRegistryCategory {
    label = 'Event';
    constructor(parent) {
        super(parent);
        super.init();
    }
    alert = () => new ActionRegistryItem({
        action: () => alert('test')
    });
    createEvent = () => new ActionRegistryItem({
        action: ({ aspect, at }) => {
            aspect.aspectEvents.eventCreation.createFromRawEvent({ type: at.trait.local.valueOf.eventType || 'click' });
        },
        params: {
            core: ['eventType']
        }
    });
    fireEvent = () => new ActionRegistryItem({
        action: ({ aspect, at }) => {
            aspect.aspectEvents.eventCreation.createAndFireFromRawEvent({
                type: at.trait.local.valueOf.eventType || 'click'
            });
        },
        params: {
            core: ['eventType']
        }
    });
    justEmitEvent = () => new ActionRegistryItem({
        action: () => { }
    });
    doNothingReserve = () => new ActionRegistryItem({
        label: 'do nothing (premount event)',
        action: () => { }
    });
    stopEventPropagation = () => new ActionRegistryItem({
        action: ({ e }) => {
            e.stopPropagation();
        }
    });
    triggerDerivedEvents = () => new ActionRegistryItem({
        action: ({ event, aspect }) => {
            if (event instanceof MouseEvent_) {
                if (event.type === 'click') {
                    if (event.reactEvent.target === event.reactEvent.currentTarget) {
                        aspect.aspectEvents.eventCreation.createAndFireFromRawEvent({ type: 'directclick' });
                    }
                    if (event.nearestAspect === aspect) {
                        aspect.aspectEvents.eventCreation.createAndFireFromRawEvent({ type: 'semidirectclick' });
                    }
                }
            }
        }
    });
}
